class BacktestBroker {
  constructor(host) {
    this._host = host;
    this._orders = [];
    this._positions = [];

    // 1. Initial Load from Firebase via Android Bridge
    // If bridge isn't ready yet, it defaults to 0 and waits for setupFirebaseListener()
    // ======================================
// LOAD BALANCE (Android or Web)
// ======================================

if (window.AndroidBridge?.getFirebaseAmount) {

  this._balance = window.AndroidBridge.getFirebaseAmount();

} else if (window.WebBridge?.getFirebaseAmount) {

  // async load
  window.WebBridge.getFirebaseAmount().then(amount => {
    this.syncBalance(amount);
  });

  this._balance = 0;

} else {

  this._balance = 0;

}
    this._equity = this._balance;

    // Expose globally for the React UI and Android bridge
    window.brokerInstance = this;
    // 🔥 Force UI refresh after chart loads
setTimeout(() => {
  if (this._balance > 0) {
    this.syncBalance(this._balance);
  }
}, 800);
    // ======================================
// REALTIME BALANCE LISTENER (WEB)
// ======================================

if (window.WebBridge?.listenBalance) {

  window.WebBridge.listenBalance((amount) => {
    this.syncBalance(amount);
  });

}
    console.log("🚀 Backtest Broker Online with Firebase Sync");
  }
  getAccountManagerInfo() {
    return {
      accountTitle: "BacktestX Demo Account",
      summary: [
        {
          text: "Balance",
          value: "$" + this._balance.toFixed(2),
        },
        {
          text: "Equity",
          value: "$" + this._equity.toFixed(2),
        },
      ],
    };
  }

  // ✅ Function called by Android when Firebase "amount" changes
  
syncBalance(newAmount) {

  this._balance = Number(newAmount) || 0;
  this._equity = this._balance;

  console.log("💰 Broker Balance Updated:", this._balance);

  // TradingView UI refresh
  try {

    if (this._host) {
      this._host.accountUpdate();
      this._host.equityUpdate(this._equity);
      this._host.accountManagerUpdate();
    }

  } catch (e) {
    console.warn("TV host not ready yet");
  }

}

  async configFlags() {
    return {
      supportMarketOrders: true,
      supportLimitOrders: true,
      supportOrderBrackets: true,
      supportPositionBrackets: true,
      supportTradeBrackets: true,
      supportModifyOrder: true,

      supportNativeAllOrdersAndPositions: true,
      supportTradingWithZeroPosition: true,

      // ⭐⭐⭐ THIS ENABLES ACCOUNT MANAGER IN V26 ⭐⭐⭐
      supportAccountManager: true,
      supportBottomWidget: true,
      supportOrderPanel: true,
    };
  }


  async symbolMetainfo(symbol) {
    return {
      symbol: symbol,
      description: symbol,
      type: "stock",
      exchange: "BACKTEST",
      listed_exchange: "BACKTEST",
      unit: "USD",
      session: "24x7",
      tradable: true,
      minTick: 0.01,
      pipSize: 0.01,
      qty: { min: 0.01, max: 10000, step: 0.01 },
    };
  }

  async accountsMetainfo() {
    return [{ id: "backtest_acc", name: "Simulator Account", currency: "USD" }];
  }

  async equity() { return this._equity; }
  async orders() { return this._orders; }
  async positions() { return this._positions; }

  setCurrentPrice(candle) {
    this._host.symbolUpdate({
      bid: candle.close,
      ask: candle.close,
      last: candle.close,
    });
  }

  // ✅ Place Order: Saves locally and draws on chart
  async placeOrder(order) {
    const orderId = "order_" + Date.now();
    const newOrder = {
      ...order,
      id: orderId,
      status: 6, // 6 = Working (required in TV v31 to show on chart)
      avgPrice: order.price,
      filledQty: order.qty,
      remainingQty: 0,
      lastUpdateTime: Date.now(),
    };

    this._orders.push(newOrder);

    // Update Charting Library UI
    this._host.orderUpdate(newOrder);
    this._host.executionUpdate({
      id: "exec_" + orderId,
      symbol: order.symbol,
      orderId: orderId,
      price: order.price,
      qty: order.qty,
      side: order.side,
      time: Date.now(),
    });

    return { orderId };
  }

  // ✅ Cancel/Close Order: Calculates PnL and updates Firebase
  async cancelOrder(orderId) {
    const orderIndex = this._orders.findIndex(o => o.id === orderId);
    if (orderIndex === -1) return;

    const order = this._orders[orderIndex];

    // 2. Calculate PnL (Using the last known replay price)
    // Formula: (Current - Entry) * Qty * Side
    const currentPrice = window.currentReplayPrice || order.price;
    const pnl = (currentPrice - order.price) * order.qty * order.side;

    const newBalance = this._balance + pnl;

    // 3. Save to Firebase via the Android Bridge
    // ======================================
// SAVE BALANCE (Android or Web)
// ======================================

if (window.AndroidBridge?.saveNewAmount) {

  console.log("📱 Saving via AndroidBridge");
  window.AndroidBridge.saveNewAmount(newBalance);

} else if (window.WebBridge?.saveNewAmount) {

  console.log("🌐 Saving via WebBridge");
  window.WebBridge.saveNewAmount(newBalance);

} else {

  // fallback
  this.syncBalance(newBalance);

}

    // 4. Cleanup
    this._orders.splice(orderIndex, 1);
    this._host.orderUpdate({ ...order, status: 1 }); // 1 = Canceled/Closed
  }

  async editOrder(order) {
    const index = this._orders.findIndex(o => o.id === order.id);
    if (index !== -1) {
      this._orders[index] = { ...this._orders[index], ...order };
      this._host.orderUpdate(this._orders[index]);
    }
  }

  checkExecutions(candle) {
    // Store global price so cancelOrder can use it for PnL
    window.currentReplayPrice = candle.close;

    this._orders.forEach(order => {
      if (!order.stopLoss && !order.takeProfit) return;

      if (order.side === 1) { // Long
        if (order.stopLoss && candle.low <= order.stopLoss) this.cancelOrder(order.id);
        else if (order.takeProfit && candle.high >= order.takeProfit) this.cancelOrder(order.id);
      } else if (order.side === -1) { // Short
        if (order.stopLoss && candle.high >= order.stopLoss) this.cancelOrder(order.id);
        else if (order.takeProfit && candle.low <= order.takeProfit) this.cancelOrder(order.id);
      }
    });
  }
}

export default BacktestBroker;